module.exports = __webpack_public_path__ + "static/media/Celeb.4f419916.jpg";